import React, { FC, useEffect } from 'react';
import {
  useGraphDataController,
  GraphToolbar,
  NewVisualizationParams,
  useGraphStatusStore,
  GraphStatus,
} from '../../../../component/NewGraph';
import { getNetworkEnum } from '@helpers/address';
import { GraphSidebar, GraphVisualization } from '@graph/modules';
import cls from './styles.module.scss';
import { useSidebarWindow } from '@graph-sidebar-module/shared';
import { useCurrancyQuery } from '@apolloGenerated';
import { useCurrencyListStore } from '@graph/libs';

export type NewVisualizationScreenProps = {
  params: NewVisualizationParams;
  query: {};
};

export const NewVisualizationScreen: FC<NewVisualizationScreenProps> = ({ params }) => {
  const { data } = useCurrancyQuery();

  const { isLoading, isInitialized, isCrash } = useGraphStatusStore();
  const { tableData, links, nodes, canvas } = useGraphDataController(params);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, { isShow }] = useSidebarWindow();

  const { setCurrencies } = useCurrencyListStore();

  useEffect(() => {
    setCurrencies(data?.currency);
  }, [data]);

  return (
    <>
      <GraphStatus hasSidebar={isShow} />
      {isInitialized && !isCrash && (
        <GraphVisualization nodes={nodes} links={links} canvas={canvas} />
      )}
      <div className={cls.container}>
        <GraphToolbar network={getNetworkEnum(params.network)} />
        <GraphSidebar
          hash={tableData?.idN}
          network={getNetworkEnum(params.network)}
          checked={tableData?.checked}
          type={tableData?.mode}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};
